module.exports = __webpack_public_path__ + "static/media/textProduct_Marketingportal.c748de3c.md";